import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
import * as LabelPrimitive from "@radix-ui/react-label";
//#region src/label/Label.tsx
const Label = ({ className, ...rest }) => {
	return /* @__PURE__ */ jsx(LabelPrimitive.Root, {
		className: twMerge("text-sm font-medium", className),
		...rest
	});
};
const LabelAsterisk = () => /* @__PURE__ */ jsxs("span", {
	className: "font-medium text-red-600",
	children: [/* @__PURE__ */ jsx("span", {
		"aria-hidden": true,
		children: "*"
	}), /* @__PURE__ */ jsx("span", {
		className: "sr-only",
		children: "(required)"
	})]
});
const Root = Label;
const Asterisk = LabelAsterisk;
//#endregion
export { Asterisk, Label, LabelAsterisk, Root };
